import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "@/components/ui/accordion";
import { HelpCircle } from "lucide-react";
import { FAQ } from "@/data/content";
import { Reveal } from "@/components/effects/Effects";

export default function Faq({ items }) {
  const faqList = (items && items.length) ? items : FAQ.items;
  return (
    <section id="faq" className="relative bg-[#080706] border-b border-white/10" data-testid="faq-section">
      <div className="max-w-3xl mx-auto px-5 py-20 lg:py-28">
        <Reveal>
          <p className="text-xs tracking-[0.4em] text-nv uppercase mb-3 flex items-center gap-2">
            <HelpCircle className="w-4 h-4" /> ČASTÉ DOTAZY
          </p>
          <h2 className="font-head text-3xl sm:text-4xl text-neutral-100 mb-10 vhs-glitch">{FAQ.title}</h2>
        </Reveal>
        <Reveal>
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {faqList.map((item, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="border-b border-white/10"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger className="font-head text-left text-base sm:text-lg text-neutral-200 hover:text-nv hover:no-underline py-5">
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="text-sm sm:text-base text-neutral-400 leading-relaxed pb-5">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
